

<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title">403</h1>
        <h3 class="text-uppercase error-subtitle">FORBIDDON ERROR!</h3>
        <p class="text-muted my-4">YOU DON'T HAVE PERMISSION TO ACCESS ON THIS SERVER.</p>
        <a href="#/" class="btn bg-gradient-primary text-white btn-rounded waves-effect waves-light mb-5">Back
            to Login</a>
    </div>
</div>